import React from "react";
import { UserPaymentTrancheApi, userPaymentsApi } from "api";
import {
  PaziaButton,
  PaziaSelect,
  PaziaFormButton,
  PaziaCheckbox,
  PaziaInput,
  Select,
} from "components/atoms";
import { PaziaModal } from "components/molecules";
import { REGISTRATION_TRANCHE_PAYMENT_STATUSES_OPTIONS, REGISTRATION_TRANCHE_PAYMENT_STATUSES } from "consts";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

interface EditTranchePriceModalProps {
  onCloseRequest: () => void;
  tranche?: UserPaymentTrancheApi;
  userId: number;
  courseId: number;
}
import { useToaster } from "utils";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { ModalPadding } from "components/templates/Modals/ModalPadding";

export const EditTranchePriceModal = ({ onCloseRequest, tranche, userId, courseId }: EditTranchePriceModalProps) => {
  const { showError, showSuccess } = useToaster();

  const onSubmit = async (data: FormValues) => {
    try {
      if (!tranche) return;
      await userPaymentsApi.changePrice(userId, courseId, tranche.courseTrancheId, { amount: data.newPrice });
      showSuccess("Wartość transzy została zmieniona");
    } catch (error) {
      console.error(error);
      showError("Wystąpił błąd podczas zmiany wartości transzy");
    } finally {
      onCloseRequest();
    }
  };

  return (
    <PaziaModal id="edit-tranche-status-modal" onCloseRequest={onCloseRequest} isOpen={!!tranche} size="2xl">
      {tranche && (
        <ModalPadding>
          <ModalHeader>Edytuj transzę</ModalHeader>
          <EditTranchePriceForm onSubmit={onSubmit} onCancel={onCloseRequest} currentPrice={tranche.amount} />
        </ModalPadding>
      )}
    </PaziaModal>
  );
};

const EditTranchePriceForm = ({
  onSubmit,
  onCancel,
  currentPrice,
}: {
  onSubmit: (data: FormValues) => Promise<void>;
  onCancel: () => void;
  currentPrice: number;
}) => {
  const schema = yup
    .object({
      currentPrice: yup.number().required(),
      newPrice: yup.number().required().min(0),
    })
    .required();

  const methods = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      currentPrice: currentPrice,
    },
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
        <PaziaInput disabled name="currentPrice" label="Aktualna wyysokość transzy" />
        <PaziaInput name="newPrice" label="Nowa wysokość transzy" type="number" step="0.01" placeholder="Wysokość transzy" />

        <div className="mt-4 flex justify-end gap-2">
          <PaziaButton btnType="button" type="tertiary" onClick={onCancel} title="Anuluj" />
          <PaziaFormButton type="success" title="Zapisz" />
        </div>
      </form>
    </FormProvider>
  );
};
type FormValues = {
  currentPrice: number;
  newPrice: number;
};
